import React from 'react';
import { useNavigate } from '@tanstack/react-router';

import { AppLayoutContainer } from '../AppLayout';
import { Config } from '../../../services/Config';

import { NotFound } from './NotFound';

export function NotFoundRoute() {
  const navigate = useNavigate();
  const handleHomeButtonClick = () => {
    navigate({ to: '/' });
  };

  return (
    <AppLayoutContainer
      helpAndSupportUrl={Config.APPLICATION_GENERAL_HELPARTICLE_URL}
      siteName={Config.APPLICATION_SHORT_DISPLAY_NAME}
    >
      <NotFound onHomeButtonClick={handleHomeButtonClick} />
    </AppLayoutContainer>
  );
}
